module.exports = __webpack_public_path__ + "img/04m-Shop_651.b99eb60f.jpg";